import { useState } from 'react';
import type { FAQItem } from '@/mocks/types';

interface FAQSectionProps {
  faqs: FAQItem[];
}

export default function FAQSection({ faqs }: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="flex flex-col gap-3">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
        >
          <button
            className="w-full px-5 py-4 flex items-center justify-between gap-4 text-left cursor-pointer"
            onClick={() => toggleFAQ(index)}
            aria-expanded={openIndex === index}
          >
            <span className="text-sm font-medium text-foreground-900">
              {faq.question}
            </span>
            <div className="w-5 h-5 flex items-center justify-center shrink-0">
              <i
                className={`text-base text-foreground-500 transition-transform duration-200 ${
                  openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                }`}
              ></i>
            </div>
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
              {faq.answer}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}